import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgBasicErrorModal',
})
export default class CmgBasicErrorModal extends Vue {
    completingOptions: object[] = [];

    get visible(): boolean {
        return this.$appStore.state.ui.modals.basicError.visible;
    }

    get background(): string {
        return this.args?.background ?? 'grey-medium';
    }

    get args() {
        return this.$appStore.state.ui.modals.basicError.args;
    }

    get header(): string | null {
        return (this.args && this.args.header) || null;
    }

    get content(): string | null {
        return (this.args && this.args.content) || null;
    }

    get options() {
        return (this.args && this.args.options) || [];
    }

    get isShort() {
        return this.args && this.args.isShort;
    }

    get unmaskContent() {
        return this.args && this.args.unmaskContent;
    }

    get isInterstitialError() {
        return this.args && this.args.isInterstitialError;
    }

    get optionsColumn() {
        return this.args && this.args.optionsColumn;
    }

    onClickOption(option: { onClick: () => void | Promise<any> }) {
        option.onClick();
        this.$services.ui.focusBack();
    }

    onClose() {
        if (this.args && this.args.onClose) {
            this.args?.onClose();
        }

        this.$services.ui.setModalVisibility('basicError', false);
    }
}
